import React from 'react';
import '../../../../layouts/Header/Header.css';
import { FaAndroid, FaApple, FaAppStoreIos, FaWindows } from 'react-icons/fa';
import IntlMessages from '../../../../intl/IntlMessages';


const DownLoadApp = ({ handleDownload }) => {
    return (
        <>
            <div className="social-links">
                <span className="testH"> <IntlMessages id="sections.construction" /> :</span>
                <span
                    className="social-link android"
                >
                    <FaAndroid size={20} onClick={handleDownload} />
                </span>

                <span
                    className="social-link ios"

                >
                    <FaAppStoreIos size={20} onClick={handleDownload} />
                </span>
                <span
                    className="social-link windows"
                >
                    <FaWindows size={20} onClick={handleDownload} />
                </span>
                <span
                    className="social-link apple"
                >
                    <FaApple size={20} onClick={handleDownload} />
                </span>
            </div>
        </>
    )
}

export default DownLoadApp;
